import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["button", "content"]

  toggleActive (e) {
    this.resetActiveButton()
    e.target.classList.add('active')

    this.contentTargets.forEach((element) => {
      element.classList.toggle('active')
    })
  }

  resetActiveButton () {
    this.buttonTargets.forEach((element) => {
      element.classList.remove('active')
    })
  }
}
